import React from "react";
import {ButtonListCell, List, StandardListCell} from "gd-react";
import GridDuck from "gridduck";
import NoItems from "../../components/noItems";
import CreateDataFileImport from "./CreateDataFileImport";
import FileImportUploadModal from "./FileImportUploadModal";
import DataFileImportLogModal from "./DataFileImportLogModal";

class DataFileImportListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {editItem: null, uploadItem: null, logItem: null, refreshRef: 0};
        this.getList = this.getList.bind(this);
        this.reload = this.reload.bind(this);
    }

    getList(params) {
        return GridDuck.getDataFileImports(params);
    }

    reload() {
        this.setState({refreshRef: this.state.refreshRef + 1});
    }

    render() {
        let columns = [
            {component: StandardListCell, title: "Name", field: "name"},
            {component: StandardListCell, title: "Description", field: "description", maxWidth: "none"},
            {
                component: StandardListCell,
                title: "Created",
                field: "created_at",
                custom: (item) => {
                    if (!item.created_at) return "";
                    let d = new Date(item.created_at);
                    return isNaN(d.getTime()) ? "" : d.toLocaleDateString();
                },
                maxWidth: "150px"
            },
            {
                component: ButtonListCell,
                title: "Logs",
                field: "id",
                icon: "FaListAlt",
                color: "gd-grey",
                onClick: (item) => this.setState({logItem: item}),
                maxWidth: "70px"
            },
            {
                component: ButtonListCell,
                title: "Upload",
                field: "id",
                icon: "FaUpload",
                color: "gd-blue",
                onClick: (item) => this.setState({uploadItem: item}),
                maxWidth: "80px"
            }
        ];
        return (
            <div className={"page white"}>
                <List
                    refreshRef={this.state.refreshRef}
                    noitemelem={<NoItems text={"You haven't set up any data imports yet"}
                                         createtext={"Set Up Data Import"}
                                         modal={CreateDataFileImport}/>}
                    columns={columns}
                    getlist={this.getList}
                    rowOnClick={(item) => this.setState({editItem: item})}
                    filters={[]}/>
                {this.state.editItem ?
                    <CreateDataFileImport open={!!this.state.editItem}
                                          item={this.state.editItem}
                                          onCreated={this.reload}
                                          onClose={() => this.setState({editItem: null})}/> : null}
                {this.state.uploadItem ?
                    <FileImportUploadModal open={!!this.state.uploadItem}
                                           item={this.state.uploadItem}
                                           onClose={() => this.setState({uploadItem: null})}/> : null}
                {this.state.logItem ?
                    <DataFileImportLogModal open={!!this.state.logItem}
                                            item={this.state.logItem}
                                            onClose={() => this.setState({logItem: null})}/> : null}
            </div>
        );
    }
}

export default DataFileImportListPage;
